// 書類作成のユーザーグループの選択
// 選んだユーザーグループはセッションに保存し、リロードや他の画面から戻っても選択を保つ（初期の選択色はサーバー側で付ける）
document.addEventListener('DOMContentLoaded', function() {
    const userGroupList = document.getElementById('user_group_list');
    const hiddenInput = document.getElementById('user_group_input');
    const selectGroup = document.getElementById('select-group');

    // #user_group_list が存在する場合のみ実行
    if (userGroupList && hiddenInput && selectGroup) {
        const listItems = userGroupList.querySelectorAll('li');
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

        listItems.forEach(li => {
            li.addEventListener('click', function() {
                // 既存の選択色をリセット
                listItems.forEach(item => item.classList.remove('bg-gray-200'));

                // クリックしたliに選択色をつける
                this.classList.add('bg-gray-200');

                // hidden-inputにidと開講ステータスをセット
                hiddenInput.value = this.dataset.id;
                hiddenInput.dataset.statusKey = this.dataset.statusKey;

                // 検索後の URL に残った user_group_id が、リロードしたときにこの選択より優先されないよう置き換える
                const url = new URL(window.location.href);
                if (url.searchParams.has('user_group_id')) {
                    url.searchParams.set('user_group_id', this.dataset.id);
                    history.replaceState(null, '', url);
                }

                // select-groupのテキストをセット
                selectGroup.textContent = this.dataset.name;

                // 選択をセッションに保存する（失敗しても、この画面の選択はそのまま使える）
                fetch(hiddenInput.dataset.selectUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                    },
                    body: JSON.stringify({ user_group_id: this.dataset.id }),
                }).catch(() => {});
            });
        });
    }
});
